import {
  branch,
  compose,
  renderComponent,
  withHandlers,
  withState,
} from 'recompose';
import { path } from 'ramda';
import RefundModalSplit from './containers/RefundModalSplit';
import RefundModal from './containers/RefundModal';

const persistSaleState = withState(
  'item',
  'setItem',
  props => props.item,
);

const RefundModalContainer = compose(
  persistSaleState,
  withState('disabled', 'setDisabled', false),
  withHandlers({
    refund: props => (...args) => {
      props.setDisabled(true);
      return props.refund(...args)
        .then(() => {
          props.close();
          props.setDisabled(false);
        })
        .catch(() => props.setDisabled(false));
    },
  }),
  branch(
    props => path(['item', 'payments', 'length'], props) > 1,
    renderComponent(RefundModalSplit)
  ),
)(RefundModal);

export default RefundModalContainer;
